<template>
    <div>
        <transition name="fade">
            <div 
                v-if="isVisible"
                class="copy-success-toast">
                <div class="copy-success-toast__content">
                    <div class="copy-success-toast__icon">
                        <img src="@/assets/icon/ic-check-white.svg" alt="copy success">
                    </div>
                    <div class="copy-success-toast__message">
                        <p class="copy-success-toast__title">{{ title }}</p>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Locale from "@/helper/locale/locale.js";

export default {
    name: "CopySuccessToast",
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        controller: Object,
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            isVisible: false,
            title: "",
            timeout: null,
            busModal: null,
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    beforeDestroy: function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    },
    methods: {
        show: function (config) {
            this.title = config.title || this.lbl.serial.copy_success_title || '';
            this.isVisible = true;

            // Auto hide after 3 seconds
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(() => {
                this.hide();
            }, 1000);
        },
        hide: function () {
            this.isVisible = false;
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";

.copy-success-toast {
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    min-width: 320px;
    max-width: 90%;
    height: 48px;
    border-radius: 4px;
    overflow: hidden;
    animation: slideUp 0.3s ease-in-out;

    .copy-success-toast__content {
        display: flex;
        align-items: stretch;
    }

    .copy-success-toast__icon {
        flex-shrink: 0;
        width: 48px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #3DA758;
        padding: 12px;
    }

    .copy-success-toast__message {
        flex: 1;
        min-width: 0;
        background: #333D47;
        padding: 14px 12px;
        height: 100%;
    }

    .copy-success-toast__title {
        font-size: 14px;
        font-weight: 400;
        color: $color-white;
        margin-bottom: 0;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
}

@keyframes slideDown {
    from {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
    to {
        opacity: 0;
        transform: translateX(-50%) translateY(20px);
    }
}

.fade-enter-active {
    animation: slideUp 0.3s ease-out;
}

.fade-leave-active {
    animation: slideDown 0.3s ease-out;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

</style>

